import { createApi } from '@reduxjs/toolkit/query/react'
import { createBffApiBaseQuery } from './apiClients'

export const donateRecordsApi = createApi({
    reducerPath: 'donateRecordsApi',
    baseQuery: createBffApiBaseQuery('donateRecordsApi', { baseUrl: `${process.env.REACT_APP_API_BASE_URL}/donaterecords` }),
    endpoints: (builder) => ({
        createPointsDonateRecord: builder.mutation({
            query: (body) => {
                return {
                    url: `/points`,
                    method: 'POST',
                    body: body
                }
            },
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response
        }),
        createAuctionDonateRecord: builder.mutation({
            query: (body) => {
                return {
                    url: `/auction`,
                    method: 'POST',
                    body: body
                }
            },
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response
        }),
        createRouletteDonateRecord: builder.mutation({
            query: (body) => {
                return {
                    url: `/roulette`,
                    method: 'POST',
                    body: body
                }
            },
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response
        }),
        getAuctionDonateRecords: builder.query({
            query: () => {
                return {
                    url: `/auction`,
                    method: 'GET'
                }
            },
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response,
        }),
        removeAuctionDonateRecord: builder.mutation({
            query: (id) => {
                return {
                    url: `/auction/${id}`,
                    method: 'DELETE'
                }
            },
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response
        }),
        removeAuctionDonateRecords: builder.mutation({
            query: (body) => {
                return {
                    url: `/auction`,
                    method: 'DELETE',
                    body: body
                }
            },
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response
        }),
    }),
})

export const { 
    useCreatePointsDonateRecordMutation,
    useCreateAuctionDonateRecordMutation,
    useCreateRouletteDonateRecordMutation,
    useGetAuctionDonateRecordsQuery, 
    useLazyGetAuctionDonateRecordsQuery,
    useRemoveAuctionDonateRecordMutation,
    useRemoveAuctionDonateRecordsMutation
} = donateRecordsApi
